export const SIZE_BY_UNDERLYING = {
  data: [
    {
      underlying: "BZUN",
      symbol: "BZUN",
      value: 11540.550000000001,
      confidence: 0,
      riskpercent: 3,
    },
    {
      underlying: "OPI",
      symbol: "OPI",
      value: 1511.55,
      confidence: 0,
      riskpercent: 0.4,
    },
    {
      underlying: "EOS",
      symbol: "EOS",
      value: 5877.04,
      confidence: 0,
      riskpercent: 1.5,
    },
    {
      underlying: "DWDP",
      symbol: "DWDP",
      value: 16811.4,
      confidence: 0,
      riskpercent: 4.4,
    },
    {
      underlying: "CIM",
      symbol: "CIM",
      value: 17118.93,
      confidence: 0,
      riskpercent: 4.5,
    },
    {
      underlying: "LAC",
      symbol: "LAC",
      value: 5250,
      confidence: 0,
      riskpercent: 1.4,
    },
    {
      underlying: "ACRE",
      symbol: "ACRE",
      value: 6182.24,
      confidence: 0,
      riskpercent: 1.6,
    },
    {
      underlying: "AAL",
      symbol: "AAL",
      value: 4447.5,
      confidence: 0,
      riskpercent: 1.2,
    },
    {
      underlying: "CTVA",
      symbol: "CTVA",
      value: 2620.1400000000003,
      confidence: 0,
      riskpercent: 0.7,
    },
    {
      underlying: "PUMGF",
      symbol: "PUMGF",
      value: 2150,
      confidence: 0,
      riskpercent: 0.6,
    },
    {
      underlying: "APPS",
      symbol: "APPS",
      value: 3672.43,
      confidence: 0,
      riskpercent: 1,
    },
    {
      underlying: "SIL",
      symbol: "SIL",
      value: 4761.49,
      confidence: 0,
      riskpercent: 1.2,
    },
    {
      underlying: "LAC",
      symbol: "LAC 20Aug21 17.5 Call",
      value: 189,
      confidence: 0,
      riskpercent: 0,
    },
    {
      underlying: "TREX",
      symbol: "TREX 20Oct17 65 Call",
      value: 2408,
      confidence: 0,
      riskpercent: 0.6,
    },
    {
      underlying: "CIK",
      symbol: "CIK",
      value: 8470.91,
      confidence: 0,
      riskpercent: 2.2,
    },
    {
      underlying: "DFS",
      symbol: "DFS 15Oct21 120 Call",
      value: 1324,
      confidence: 0,
      riskpercent: 0.3,
    },
    {
      underlying: "EVT",
      symbol: "EVT",
      value: 7933.11,
      confidence: 0,
      riskpercent: 2.1,
    },
    {
      underlying: "IWM",
      symbol: "IWM",
      value: 176.12000000000003,
      confidence: 0,
      riskpercent: 0,
    },
    {
      underlying: "BCE",
      symbol: "BCE",
      value: 8657,
      confidence: 0,
      riskpercent: 2.3,
    },
    {
      underlying: "REGI",
      symbol: "REGI",
      value: 5636.62,
      confidence: 0,
      riskpercent: 1.5,
    },
    {
      underlying: "SPY",
      symbol: "SPY 29Sep17 230 Call",
      value: 1662,
      confidence: 0,
      riskpercent: 0.4,
    },
    {
      underlying: "OXLC",
      symbol: "OXLC",
      value: 7440.8,
      confidence: 0,
      riskpercent: 1.9,
    },
    {
      underlying: "MTCH",
      symbol: "MTCH 18Jan19 53 Call",
      value: 10,
      confidence: 0,
      riskpercent: 0,
    },
    {
      underlying: "MFA",
      symbol: "MFA",
      value: 4732.15,
      confidence: 0,
      riskpercent: 1.2,
    },
    {
      underlying: "APPS",
      symbol: "APPS 20Aug21 59 Put",
      value: 226,
      confidence: 0,
      riskpercent: 0.1,
    },
    {
      underlying: "RNP",
      symbol: "RNP",
      value: 8007.94,
      confidence: 0,
      riskpercent: 2.1,
    },
    {
      underlying: "ARGO",
      symbol: "ARGO",
      value: 4925.9,
      confidence: 0,
      riskpercent: 1.3,
    },
    {
      underlying: "ABR",
      symbol: "ABR",
      value: 2353.35,
      confidence: 0,
      riskpercent: 0.6,
    },
    {
      underlying: "PALAF",
      symbol: "PALAF",
      value: 4534.25,
      confidence: 0,
      riskpercent: 1.2,
    },
    {
      underlying: "URA",
      symbol: "URA",
      value: 1209.14,
      confidence: 0,
      riskpercent: 0.3,
    },
    {
      underlying: "CELH",
      symbol: "CELH 20Aug21 65 Put",
      value: 205,
      confidence: 0,
      riskpercent: 0.1,
    },
    {
      underlying: "JD",
      symbol: "JD 15Sep17 38 Call",
      value: 2700,
      confidence: 0,
      riskpercent: 0.7,
    },
    {
      underlying: "ETV",
      symbol: "ETV",
      value: 8099.75,
      confidence: 0,
      riskpercent: 2.1,
    },
    {
      underlying: "BPYU",
      symbol: "BPYU",
      value: 7981.32,
      confidence: 0,
      riskpercent: 2.1,
    },
    {
      underlying: "LAD",
      symbol: "LAD",
      value: 1171.42,
      confidence: 0,
      riskpercent: 0.3,
    },
    {
      underlying: "WGO",
      symbol: "WGO 15Oct21 65 Call",
      value: 1030,
      confidence: 0,
      riskpercent: 0.3,
    },
    {
      underlying: "MP",
      symbol: "MP 20Aug21 35 Put",
      value: 280,
      confidence: 0,
      riskpercent: 0.1,
    },
    {
      underlying: "BAX",
      symbol: "BAX",
      value: 11162.509999999998,
      confidence: 0,
      riskpercent: 2.9,
    },
    {
      underlying: "PROSY",
      symbol: "PROSY",
      value: 1175.5,
      confidence: 0,
      riskpercent: 0.3,
    },
    {
      underlying: "ABBV",
      symbol: "ABBV",
      value: 9574.58,
      confidence: 0,
      riskpercent: 2.5,
    },
    {
      underlying: "CLF",
      symbol: "CLF 17Sep21 22 Put",
      value: 318,
      confidence: 0,
      riskpercent: 0.1,
    },
    {
      underlying: "TALK",
      symbol: "TALK",
      value: 0.3,
      confidence: 0,
      riskpercent: 0,
    },
    {
      underlying: "DE",
      symbol: "DE 19Jan18 110 Call",
      value: 954,
      confidence: 0,
      riskpercent: 0.2,
    },
    {
      underlying: "MTCH",
      symbol: "MTCH 18Jan19 55 Call",
      value: 1418,
      confidence: 0,
      riskpercent: 0.4,
    },
    {
      underlying: "CRSR",
      symbol: "CRSR 20Aug21 35 Call",
      value: 332,
      confidence: 0,
      riskpercent: 0.1,
    },
    {
      underlying: "CYH",
      symbol: "CYH 20Aug21 14 Put",
      value: 300,
      confidence: 0,
      riskpercent: 0.1,
    },
    {
      underlying: "NLS",
      symbol: "NLS",
      value: 6750,
      confidence: 0,
      riskpercent: 1.8,
    },
    {
      underlying: "CX",
      symbol: "CX",
      value: 5842.06,
      confidence: 0,
      riskpercent: 1.5,
    },
    {
      underlying: "REGI",
      symbol: "REGI 17Sep21 70 Call",
      value: 135,
      confidence: 0,
      riskpercent: 0,
    },
    {
      underlying: "WB",
      symbol: "WB 20Oct17 60 Call",
      value: 2318,
      confidence: 0,
      riskpercent: 0.6,
    },
    {
      underlying: "JNJ",
      symbol: "JNJ",
      value: 6299.53,
      confidence: 0,
      riskpercent: 1.6,
    },
    {
      underlying: "CVX",
      symbol: "CVX",
      value: 47.49000000000001,
      confidence: 0,
      riskpercent: 0,
    },
    {
      underlying: "AMZN",
      symbol: "AMZN",
      value: 2068.4,
      confidence: 1,
      riskpercent: 0.5,
    },
    {
      underlying: "MP",
      symbol: "MP 20Aug21 30 Put",
      value: 326,
      confidence: 0,
      riskpercent: 0.1,
    },
    {
      underlying: "XIV",
      symbol: "XIV",
      value: 2037.6800000000003,
      confidence: 0,
      riskpercent: 0.5,
    },
    {
      underlying: "COPX",
      symbol: "COPX",
      value: 5384.28,
      confidence: 0,
      riskpercent: 1.4,
    },
    {
      underlying: "UNFI",
      symbol: "UNFI 20Aug21 35 Put",
      value: 568,
      confidence: 0,
      riskpercent: 0.1,
    },
    {
      underlying: "M",
      symbol: "M 20Aug21 18 Put",
      value: 270,
      confidence: 0,
      riskpercent: 0.1,
    },
    {
      underlying: "CELH",
      symbol: "CELH 20Aug21 60 Put",
      value: 470,
      confidence: 0,
      riskpercent: 0.1,
    },
    {
      underlying: "NLS",
      symbol: "NLS 20Aug21 22.5 Call",
      value: 150,
      confidence: 0,
      riskpercent: 0,
    },
    {
      underlying: "BST",
      symbol: "BST",
      value: 2569.92,
      confidence: 0,
      riskpercent: 0.7,
    },
    {
      underlying: "CQQQ",
      symbol: "CQQQ",
      value: 4079.4800000000005,
      confidence: 0,
      riskpercent: 1.1,
    },
    {
      underlying: "SNR",
      symbol: "SNR",
      value: 1884.12,
      confidence: 0,
      riskpercent: 0.5,
    },
    {
      underlying: "MCD",
      symbol: "MCD",
      value: 6865.04,
      confidence: 0,
      riskpercent: 1.8,
    },
    {
      underlying: "AAPL",
      symbol: "AAPL",
      value: 25.64568,
      confidence: 1,
      riskpercent: 0,
    },
    {
      underlying: "NVDA",
      symbol: "NVDA 17Nov17 150 Call",
      value: 3200,
      confidence: 0,
      riskpercent: 0.8,
    },
    {
      underlying: "NLY",
      symbol: "NLY",
      value: 7639.2,
      confidence: 0,
      riskpercent: 2,
    },
    {
      underlying: "RYLD",
      symbol: "RYLD",
      value: 12935.78,
      confidence: 0,
      riskpercent: 3.4,
    },
    {
      underlying: "O",
      symbol: "O",
      value: 6948.84,
      confidence: 0,
      riskpercent: 1.8,
    },
    {
      underlying: "NOC",
      symbol: "NOC 17Nov17 255 Call",
      value: 3809,
      confidence: 0,
      riskpercent: 1,
    },
    {
      underlying: "AGNC",
      symbol: "AGNC",
      value: 289.77,
      confidence: 0,
      riskpercent: 0.1,
    },
    {
      underlying: "BABA",
      symbol: "BABA",
      value: 5131.07,
      confidence: 0,
      riskpercent: 1.3,
    },
    {
      underlying: "V",
      symbol: "V 15Sep17 90 Call",
      value: 3090,
      confidence: 0,
      riskpercent: 0.8,
    },
    {
      underlying: "EVA",
      symbol: "EVA",
      value: 5870.110000000001,
      confidence: 0,
      riskpercent: 1.5,
    },
    {
      underlying: "QYLD",
      symbol: "QYLD",
      value: 17066.35,
      confidence: 0,
      riskpercent: 4.5,
    },
    {
      underlying: "KMX",
      symbol: "KMX 20Oct17 60 Call",
      value: 1862,
      confidence: 0,
      riskpercent: 0.5,
    },
    {
      underlying: "DD",
      symbol: "DD",
      value: 6712.03,
      confidence: 0,
      riskpercent: 1.8,
    },
    {
      underlying: "DHI",
      symbol: "DHI 20Aug21 100 Call",
      value: 1100,
      confidence: 0,
      riskpercent: 0.3,
    },
    {
      underlying: "TTWO",
      symbol: "TTWO 15Dec17 65 Call",
      value: 2480,
      confidence: 0,
      riskpercent: 0.6,
    },
    {
      underlying: "CRSR",
      symbol: "CRSR",
      value: 7000,
      confidence: 0,
      riskpercent: 1.8,
    },
    {
      underlying: "GOGL",
      symbol: "GOGL",
      value: 5170,
      confidence: 0,
      riskpercent: 1.3,
    },
    {
      underlying: "FCX",
      symbol: "FCX",
      value: 5979.56,
      confidence: 0,
      riskpercent: 1.6,
    },
    {
      underlying: "OIH",
      symbol: "OIH 19Jan18 30 Put",
      value: 2130,
      confidence: 0,
      riskpercent: 0.6,
    },
    {
      underlying: "VHT",
      symbol: "VHT",
      value: 4128.22,
      confidence: 0,
      riskpercent: 1.1,
    },
    {
      underlying: "KRBN",
      symbol: "KRBN",
      value: 5312.25,
      confidence: 0,
      riskpercent: 1.4,
    },
    {
      underlying: "APPS",
      symbol: "APPS 20Aug21 75 Call",
      value: 300,
      confidence: 0,
      riskpercent: 0.1,
    },
    {
      underlying: "GOV",
      symbol: "GOV",
      value: 2435.8600000000006,
      confidence: 0,
      riskpercent: 0.6,
    },
    {
      underlying: "DOW",
      symbol: "DOW",
      value: 4309.91,
      confidence: 0,
      riskpercent: 1.1,
    },
    {
      underlying: "SCHD",
      symbol: "SCHD",
      value: 9319.17,
      confidence: 0,
      riskpercent: 2.4,
    },
    {
      underlying: "ARKG",
      symbol: "ARKG",
      value: 2861.04,
      confidence: 0,
      riskpercent: 0.7,
    },
    {
      underlying: "BLMN",
      symbol: "BLMN 15Oct21 30 Call",
      value: 1520,
      confidence: 0,
      riskpercent: 0.4,
    },
    {
      underlying: "IHI",
      symbol: "IHI",
      value: 8055.16,
      confidence: 0,
      riskpercent: 2.1,
    },
  ],
  chartProperties: {
    name: "Size By Underlying",
    chartType: "treemap",
    keys: ["underlying", "symbol", "value", "confidence"],
    colors: ["var(--chart-orange)"],
    legend: ["underlying"],
    domainType: "SIZE_BY_UNDERLYING",
  },
};
